(function () {

    'use strict';

    angular
        .module('app.search')
        .controller('SearchResultController', [
            'APP_CONFIG',
            '$scope',
            '$location',
            '$routeParams',
            '$q',
            '$anchorScroll',
            '$cookies',
            'SearchService',
            'BreadcrumbService',
            'PaginationService',
            'ParamIteratorService',
            'SortingService',
            'ConditionManagerService',
            'UrlCreationService',
            'ConfigService',
            'OpenlaneService',
            'ApiService',
            'GaService',
            'uuid',
            'LoggerApi',
            'DataService',
            'CacheSearchParams',
            '$timeout',
            SearchResultController
        ]);

        function SearchResultController(APP_CONFIG, $scope, $location, $routeParams, $q, $anchorScroll, $cookies, searchService, breadcrumbService, paginationService, paramIteratorService, sortingService, conditionManagerService, urlCreationService, configService, openlaneService, apiService,
                                        gaService, uuid, loggerApiService, dataService, CacheSearchParams, $timeout){
            var isCookiedAnnouncement = true;
            var _uuid = uuid.v4();
            var specificLationSelected = [];
            var config = configService.srConfig();
            var model = {};
            var index = 3;
            var indexGrade = '-1';
            var indexYear = 0;
            var indexOdometer = 0;
            var isSearchSuccess=false;

            $scope.model = model;

            init();
            function init() {
                gaService.gaTrackPageViewAsync($location.path().toString(), 'Search Result Page');
                scroll_up_button_enable();
            }

            $scope.announOptionValue=[];

            //search results
            searchService.winnowingValues().then(function(response){
                var response = response.data;
                $scope.years = response.years;
                $scope.endYearRange = $scope.years[0].id;
                $scope.startYearRange = $scope.years[$scope.years.length - 1].id;
                $scope.pageSizes = response.pageSizes;

                if ( $routeParams.langCode == 'en') {
                    $scope.gradeSizes = response.gradeSizesEn;
                }
                if ( $routeParams.langCode == 'fr') {
                    $scope.gradeSizes = response.gradeSizesFr;
                }
                $scope.odometerList = response.odometer;
                $scope.startOdometerRange =  $scope.odometerList[0].id;
                $scope.endOdometerRange = $scope.odometerList[$scope.odometerList.length - 1].id;
            }, function(err){
                console.log('err', err);
            });

            // a list of 'Other' winnowing options
            model.otherOptions = config.otherOptions;

            // required to correctly display the breadcrumbService
            var conditionDisplayFormatters = {
                "prr": function (value) {
                    return breadcrumbService.rangedConditionDisplayFormatter(value, function (v) {
                        return (formatCurrencyForEnglish(v));
                    })
                },
                "od": function (value) {
                    return breadcrumbService.rangedConditionDisplayFormatter(value, function (v) {
                        return (formatNumber(v)+ dataService.getCurrentTranslation()['searchBreadCrumbOdometerKm']);
                    })
                },
                "grd": function (value) {
                    return breadcrumbService.rangedConditionDisplayFormatter(value, function (v) {
                        return (formatNumber(v)+ dataService.getCurrentTranslation()['searchBreadCrumbOdometerKm']);
                    })
                }
            };

            var checkboxConditions = config.checkboxConditions;
            model.otherOptions.forEach(function (opt) {
                conditionDisplayFormatters[opt.cond] = (function (x) {
                    return function () {
                        return x
                    }
                })(opt.desc);
                checkboxConditions.push(opt.cond)
            });

            var apiFields = ["VEHICLE_ID", "VIN", "SOLD", "RUNLIST_EVENT_DATE", "RUNLIST_NUMBER", "AUCTION_CH_LST", "LB_LANE", "GRADE", "MAKE_NAME",
                "LIVEBLOCK_SCHEDULED_SALE_DATE", "YEAR", "MAKE_NAME", "RUNLIST_BODYTYPE", "RUNLIST_DOORS", "ENGINE", "ODOMETER", "EXT_COLOR",
                "SELLER_DESCRIPTION", "STPA", "MODEL_NAME", "RUNLIST_OPTIONS", "RUNLIST_ANNOUNCEMENTS", "THIRD_PARTY_INSPECTION", "INSPECTION_BRANDING", "GRADE_SHORT_VALUE", "AUCTION_CH_LST", "UOM", "REVIEWED","LB_MSRP"];

            model.sortableHeaders = config.sortableHeaders;

            var sortableCriteria = config.sortableCriteria;
            model.sortableCriteria = sortableCriteria;

            // some specially treated conditions
            // always - apply every time, unconditionally
            // ifNotSet - apply every time, only if not set in the condition manager
            // default - apply only the first time
            var defaultConditionValuesConfig =
                [{"cond": "sz", "value": 100, "application": "ifNotSet"},
                    {"cond": "grdr.l", "value": '-1', "application": "ifNotSet"},
                    {"cond": "grdr.u", "value": '5.0', "application": "ifNotSet"},
                    // 100 if not set
                    // {"cond": "st", "value": 0, "application": "ifNotSet"} // 0 if not set
                ];


            model.permanentConditions = (function () {
                var pc = {};
                defaultConditionValuesConfig.filter(function (x) {
                    return (x.application == "always")
                }).forEach(function (x) {
                    pc[x.cond] = true
                });
                return pc;
            })();

            var conditionManager = conditionManagerService.createConditionManager(checkboxConditions, defaultConditionValuesConfig);
            model.message = conditionManager.message;
            model.checkboxGroupMessage = conditionManager.checkboxGroupMessage;

            var currentSort;
            var sort = {
                "set": sortingService.set,
                "getSetDir": function (s) {
                    return sortingService.getSetDir(s, currentSort);
                },
                "doSort": function (sortableHeader) {

                    //logging application event for clicking sortableheaders
                    loggerApiService.applicationEvent(3, "form1", "", "*","searchResult","",_uuid);
                    loggerApiService.applicationEventAddEvent("clicked","sortHeader/"+sortableHeader.name)
                    loggerApiService.applicationEventStart();
                    updateUrl({"sort": sortableHeader.sort});

                }
            };
            model.sort = sort;


            var criteria = {};
            $scope.criteria = criteria;

            $scope.refineSingleChoice = function (criteriaName,cond, val) {
                loggerApiService.applicationEvent(3, "form1", "", "*","searchResult","",_uuid);
                loggerApiService.applicationEventAddEvent("Winnowing",criteriaName);
                loggerApiService.applicationEventStart();
                model.checkboxGroupMessage[cond].crude = {};
                model.checkboxGroupMessage[cond].crude[val] = true;
                conditionManager.setCondition('st', 0);
                $scope.valueChanged();
            };

            var recordIndex = {};

            // calling this function updates the page
            function update(currRouteParams) {

                // update the conditionManager with the current URL parameters - this will also set any default conditions
                conditionManager.updateModel(currRouteParams);
                // re-calculate URL from the condition manager - has the default conditions
                currRouteParams = conditionManager.calculateSearchParams();

                currentSort = sortingService.getCurrentSort(currRouteParams);
                if (!currentSort || currentSort.length == 0) {
                    currentSort = sortableCriteria[0].sort;
                }
                findSortSelectionMatch(currentSort);
                function findSortSelectionMatch(currentSort) {
                    for (var i in sortableCriteria) if (sortableCriteria.hasOwnProperty(i)) {
                        if (sortingService.matches(currentSort, sortableCriteria[i].sort) == 1) {
                            sort.sortSelection = sortableCriteria[i];
                            return;
                        }
                    }
                    sort.sortSelection = {};
                }

                $q.all([openlaneService.initSearchContext(),
                    //take selected location value of the pages
                    apiService.getLocations($routeParams.langCode).then(function (response) {

                        //set specific location selected is home or other location
                        if ($routeParams.locCode === APP_CONFIG.DEFAULT_HOME) {
                            var loc;
                            for (var i = 0; i < response.data.length; i++) {
                                loc = response.data[i];
                                if (loc.locationCode !== APP_CONFIG.DEFAULT_HOME) {
                                    specificLationSelected.push(loc.locationId);
                                }
                            }
                        } else {
                            specificLationSelected.push(apiService.getLocationByCode(response.data, $routeParams.locCode).locationId);
                        }

                        //do the search
                        searchService.getSearchContext($scope).then(
                            function (searchContext) {
                            searchService.search($scope, function (searchContext) {
                                // apply conditions
                                prepareSearchContextConditions(searchContext, currRouteParams);
                                // request info for the breadcrumbService
                                paramIteratorService.forEachParam(currRouteParams, searchContext,
                                    function (cn, v) {
                                        // need to request enumeration for the breadcrumbService display
                                        if (OpenlaneSearchEngine.supportedConditions[cn].enumeration)
                                            searchContext.getCondition(cn).requestEnumeration();
                                    });
                                // sorting
                                prepareSearchContextSort(searchContext, currentSort);

                                // request fields
                                for (var fName in apiFields) if (apiFields.hasOwnProperty(fName)) searchContext.addField(apiFields[fName]);
                                // request facets/enumerations for the left-side panel
                                checkboxConditions.forEach(function (cn) {
                                    config.getApplicableValuesConfig(cn).requestor(searchContext, conditionManager);
                                });
                                searchContext.setResponseScope(19);
                            }).then(function (searchResult) {

                                    var e = searchResult.getApplicableConditionValues();
                                    if (e && e.pao && e.pao.data) {
                                        try {
                                            if (replaceLocationName && replaceLocationName.length > 0) {
                                                replaceLocationName.forEach(l => {
                                                    if (l.nfrom && l.nto) {
                                                        for (var i = 0; i < e.pao.data.length; i++) {
                                                            if (e.pao.data[i] && e.pao.data[i].name && e.pao.data[i].name.toUpperCase().indexOf(l.nfrom.toUpperCase()) >= 0) {
                                                                e.pao.data[i].name = l.nto;
                                                            }
                                                        }
                                                        if (e.pao.enum) {
                                                            for (var i = 0; i < e.pao.enum.length; i++) {
                                                                if (e.pao.enum[i] && e.pao.enum[i].name && e.pao.enum[i].name.toUpperCase().indexOf(l.nfrom.toUpperCase()) >= 0) {
                                                                    e.pao.enum[i].name = l.nto;
                                                                }
                                                            }
                                                        }
                                                    }

                                                })
                                            }
                                        } catch (err) {

                                        }
                                    }

                                    //assign value model for range criteria with ng-option
                                    index = $scope.pageSizes.map(function (item) {
                                        return item.name;
                                    }).indexOf(model.message['sz'].toString());

                                    $scope.selectedSize = $scope.pageSizes[index];

                                    indexGrade = $scope.gradeSizes.map(function (item) {
                                        return item.id;
                                    }).indexOf(model.message['grdr.l'].toString());

                                    model.gradeLowSelected = $scope.gradeSizes[indexGrade];

                                    indexGrade = $scope.gradeSizes.map(function (item) {
                                        return item.id;
                                    }).indexOf(model.message['grdr.u'].toString());

                                    model.gradeUpperSelected = $scope.gradeSizes[indexGrade];

                                    indexYear= $scope.years.map(function (item) {
                                        return item.id;
                                    }).indexOf(isUndefinedOrNull(model.message['yr.l']) ? $scope.startYearRange : model.message['yr.l'].toString());

                                    model.startYearSelected = $scope.years[indexYear];

                                    indexYear= $scope.years.map(function (item) {
                                        return item.id;
                                    }).indexOf(isUndefinedOrNull(model.message['yr.u']) ? $scope.endYearRange : model.message['yr.u'].toString());

                                    model.endYearSelected = $scope.years[indexYear];

                                    indexOdometer= $scope.odometerList.map(function (item) {
                                        return item.id;
                                    }).indexOf(isUndefinedOrNull(model.message['od.l']) ? $scope.startOdometerRange : model.message['od.l'].toString());

                                    model.startOdometerSelected = $scope.odometerList[indexOdometer];

                                    indexOdometer= $scope.odometerList.map(function (item) {
                                        return item.id;
                                    }).indexOf(isUndefinedOrNull(model.message['od.u']) ? $scope.endOdometerRange : model.message['od.u'].toString());

                                    model.endOdometerSelected = $scope.odometerList[indexOdometer];

                                    var conditionValues = searchResult.getApplicableConditionValues();
                                    Object.keys(conditionValues).forEach(function (key) {
                                        criteria[key] = config.getApplicableValuesConfig(key).transformer(conditionValues, conditionManager, criteria);
                                    });

                                    combineOtherNamesInCriteria('trm', '-9999');
                                    combineOtherNamesInCriteria('md', '2');
                                    combineOtherNamesInCriteria('mk', '1');

                                    function combineOtherNamesInCriteria(parameter, idToRemove) {

                                      var countOfOthers = 0;
                                      var criteriasArr = criteria[parameter];

                                      removeOthers(criteriasArr, idToRemove);

                                      function removeOthers(arrayOfCtriterias, idToRemove) {
                                        for (var i = 0; i < criteriasArr.length; i++) {
                                          if(Number(arrayOfCtriterias[i]['id']) == idToRemove){
                                            countOfOthers += Number(arrayOfCtriterias[i]['count']);
                                            arrayOfCtriterias.splice(i,1);
                                            removeOthers(arrayOfCtriterias, idToRemove);
                                          }
                                        }
                                      }

                                      criteriasArr.push({
                                            count : countOfOthers,
                                            id : idToRemove,
                                            md : "null",
                                            mk : "null",
                                            name: "Other"
                                        });

                                      criteria[parameter] = criteriasArr;

                                    }

                                    model.result = searchResult.getRecords();

                                    //store search results
                                    // var currentPageVIDs = [];
                                    // currentPageVIDs.push(model.result.map(function(item){
                                    //     return item.VEHICLE_ID;
                                    // }));
                                    // CacheSearchResults.storeCurrentPageSearchDetails(currentPageVIDs[0]);

                                    recordIndex = model.result.reduce(function (acc, record) {
                                        acc[record.VEHICLE_ID] = record;
                                        return acc
                                    }, {});

                                    updateMtags(model.result);
                                    model.numFound = searchResult.getNumFound();

                                    model.setConditions = breadcrumbService.getSetConditions(searchResult,
                                        function (condName) {
                                            return condName !== 'auch' && condName !== 'sz' && condName !== 'st' && condName != 'srtp'
                                        },
                                        conditionDisplayFormatters);


                                    model.removeCondition = function (removedCondName) {
                                        updateUrl({"removedCondition": removedCondName});
                                    };

                                    model.updatePagination = function (st) {
                                        if (!isUndefinedOrNull(st)) {
                                            conditionManager.setCondition('st', st);
                                            updateUrl();
                                        }
                                        $anchorScroll();

                                    };

                                    //called when pagination select tag value change
                                    model.updatePaginationSize = function (sz) {
                                        if (!isUndefinedOrNull(sz)) {
                                            conditionManager.setCondition('sz', sz.name);
                                            updateUrl();
                                        }

                                    };

                                    model.updateWinnowingRangedValue = function (rangeFieldName,gradeRange,condName) {
                                        loggerApiService.applicationEvent(3, "form1", "", "*","searchResult","",_uuid);
                                        loggerApiService.applicationEventAddEvent("clicked","winnowing/"+rangeFieldName+":"+gradeRange.id);
                                        loggerApiService.applicationEventStart();
                                        if (!isUndefinedOrNull(gradeRange) && !isUndefinedOrNull(condName)) {
                                            conditionManager.setCondition(condName, gradeRange.id);
                                            updateUrl();
                                        }
                                    };

                                    //clear criteria set base on parameter passed
                                    $scope.clear = function (viewAllField,condName) {
                                        loggerApiService.applicationEvent(3, "form1", "", "*","searchResult","",_uuid);
                                        loggerApiService.applicationEventAddEvent("clicked","winnowing/"+viewAllField);
                                        loggerApiService.applicationEventStart();
                                        if (!condName) return;
                                        condName = [].concat(condName);
                                        condName.forEach(function (x) {
                                            conditionManager.clearCondition(x);
                                        });
                                        updateUrl();
                                    };

                                    //pagination link to the selected page buttons
                                    model.links = paginationService.getLinks(searchResult, conditionManager.message['sz']);

                                    updateModel(searchResult, currRouteParams);

                                    model.rewrittenUrl = urlCreationService.createUrl(true);

                                    model.loading = false;

                                    isSearchSuccess = true;

                                    loggerApiService.applicationEventStop();
                                });
                        },function(err){
                            model.loading = false;
                        });
                    },function(err){
                        console.log(err);
                    })
                ]);
            }


            function prepareSearchContextConditions(searchContext, params) {
                searchContext.getCondition('auch').setValue(["rl", "lb"]);
                searchContext.getCondition('pao').setValue(specificLationSelected);
                searchContext.addField('THUMBNAIL_URL');
                paramIteratorService.forEachParam(params, searchContext,
                    function (cn, v) {
                        searchContext.getCondition(cn).setValue(v);
                    },
                    function (cn, l, u) {
                        searchContext.getCondition(cn).setRangeValue(l, u)
                    });
            }

            function prepareSearchContextSort(searchContext, currentSort) {
                searchContext.resetSort();
                var sorts = currentSort;
                for (var sortInd in sorts) if (sorts.hasOwnProperty(sortInd)) {
                    var sortApiField = searchContext.getSortField(sorts[sortInd].name);
                    if (sortApiField) sortApiField.add(sorts[sortInd].dir == 'd');
                }
            }

            function getReportUrl(config) {
                var deferred = $q.defer();
                if (config["download"] === undefined) config["download"] = true;
                if (config["ignorePagination"] === undefined) config["ignorePagination"] = true;
                searchService.getSearchContext($scope).then(function (searchContext) {
                    var currRouteParams = conditionManager.calculateSearchParams();

                    prepareSearchContextConditions(searchContext, currRouteParams);
                    prepareSearchContextSort(searchContext, currentSort);
                    deferred.resolve(searchContext.getReportUrl(config["format"], {
                        download: config["download"],
                        ignorePagination: config["ignorePagination"]
                    }, config["reportName"]));
                });

                return deferred.promise;
            }

            function getSearchResultCount(callback) {
                searchService.search($scope, function (searchContext) {
                    prepareSearchContextConditions(searchContext, conditionManager.calculateSearchParams());
                    searchContext.getCondition('auch').setValue(["rl", "lb"]);
                    searchContext.getCondition("sz").setValue(0);
                    searchContext.setResponseScope(OpenlaneSearchEngine.ResponseScope.COUNT);
                    searchContext.addField("VEHICLE_ID");
                })
                    .then(function (searchResult) {
                        var numFound = searchResult.getNumFound();
                        callback(numFound);
                    });
            }

            $scope.openWithExcelTabLink = function () {
                getSearchResultCount(function (numFound) {
                    var MAX = 1500;
                    if (numFound > MAX) {
                        alert("The maximum number of vehicles allowed is " + MAX + ". Please narrow your search and try again.");
                    }
                    else {
                        //download();
                        
                    	searchService.getSearchContext($scope).then(function (searchContext) {
							var currRouteParams = conditionManager.calculateSearchParams();

							prepareSearchContextConditions(searchContext, currRouteParams);
							prepareSearchContextSort(searchContext, currentSort);
							
							var stateSerialized = searchContext.serializeState();
							var factory=searchContext.getSearchContextFactory();
							var searchContextClone =factory.createSearchContext();
							searchContextClone.setState(stateSerialized);
							
							if(searchContextClone){
							   searchContextClone.getCondition("sz").remove();
							   searchContextClone.getCondition("st").remove();
							}
							
							var url = OpenlaneSearchEngine.reportBaseUrl + '/report?_rep='+
							OpenlaneSearchEngine.reports.BI_SRP_EXCEL + '&_fmt=' + "xls" +"&coid=" + 
							OpenlaneSearchEngine.currentOrgId +"&"+
	                        searchContextClone.serializeState()+"&_attch=true";
							
							
							var jstate=OpenlaneSearchEngine.jstate;
                            var req = new XMLHttpRequest();
                    		req.open('GET', url, true);
                    		req.responseType = 'arraybuffer';
                    		req.onreadystatechange = function (aEvt) {
                    			if (req.readyState == 4) {
                    				if(req.status == 200) {
                    					var filename = "Search Result";
                    					var disposition = req.getResponseHeader('Content-Disposition');
                    					if (disposition && disposition.indexOf('attachment') !== -1) {
                    						var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    						var matches = filenameRegex.exec(disposition);
                    						if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                    					}
                    					var type = req.getResponseHeader('Content-Type');
                    					var blob = new Blob([this.response], { type: type });
                    					var a = document.createElement("a");
                    					a.href = URL.createObjectURL(blob);
                    					a.setAttribute("download", filename);
                    					a.click();
                    				}else{
                    					alert("Error download...");
                    				}
                    			}
                    		};
                    		req.setRequestHeader("_jstate", jstate);
                    		req.send();
							
						});
                    }
                });

                function download() {


                    getReportUrl({
                        "format": "xls",
                        "download": true,
                        "ignorePagination": true,
                        "reportName": OpenlaneSearchEngine.reports.BI_SRP_EXCEL
                    })
                        .then(function (url) {
                            window.location.href = url
                        })
                }
            };

            $scope.printRunlist = function () {
                getReportUrl({
                    "format": "pdf",
                    "download": false,
                    "ignorePagination": true,
                    "reportName": OpenlaneSearchEngine.reports.RUNLIST
                })
                    .then(function (url) {
                        window.open(url);
                        return false;
                    })
            };

            $scope.downloadTabLink = function () {
                getSearchResultCount(function (numFound) {
                    var MAX = 1500;
                    if (numFound > MAX) {
                        alert("NOTE: Maximum number of vehicles displayed is " + MAX + ".");
                    }
                    download();
                });

                function download() {
                    getReportUrl({
                        "format": "pdf",
                        "download": true,
                        "ignorePagination": true,
                        "reportName": OpenlaneSearchEngine.reports.BI_SRP
                    })
                        .then(function (url) {
                            window.location.href = url
                        })
                }
            };

            $scope.valueChanged = function () {
                updateUrl();
            };

            $scope.selectAll = function (condName) {
                conditionManager.selectAll(condName, criteria);
                $scope.valueChanged();
            };

            $scope.selectSome = function (condName) {
                conditionManager.selectSome(condName);
                $scope.valueChanged();
            };

            // update the page when URL changes
            $scope.$watch(function () {
                return $location.search();
            }, function (value, oldValue) {
                if (value) {
                    model.loading = true;
                    update(value);
                }
            });

            var updated = false;
            // The purpose of this function is to translate the free text txt condition into other conditions.
            // This must only happen once. We do not want constantly overwriting the client conditions by the ones
            // returned from the server.
            function updateModel(searchResult, currRouteParams) {
                if (updated) return;
                updated = true;
                var search = currRouteParams;
                var sc = searchResult.getSearchContext();
                var cvs = sc.getConditionValues();
                for (var cn in cvs) if (cvs.hasOwnProperty(cn)) {
                    var cv = cvs[cn];
                    if (cv.isRangeValue()) {
                        var lower = cv.getLower();
                        var upper = cv.getUpper();

                        if (lower !== undefined && lower !== null) search[cn + ".l"] = lower;
                        if (upper !== undefined && upper !== null) search[cn + ".u"] = upper;
                    }
                    else
                        search[cn] = cv.getValue();
                }

                conditionManager.updateModel(search);
            }

            function getSetConditionNames(searchContext) {
                var conditions = [];
                var cvs = searchContext.getConditionValues();
                for (var cn in cvs) if (cvs.hasOwnProperty(cn)) {
                    conditions.push(cn);
                }
                return conditions;
            }


            // update current URL with parameters from search results
            function updateUrl(params) {

                model.loading = true;
                if (!params) params = {};
                var search = conditionManager.calculateSearchParams(params.removedCondition);
                var isReload = false;

                if(search['grdr.l'] > search['grdr.u']){
                    var grdLower = search['grdr.l'];
                    var grdUpper= search['grdr.u'];

                    search['grdr.l']=grdUpper;
                    search['grdr.u']=grdLower;
                }

                if(parseInt(search['od.l']) > parseInt(search['od.u'])){
                    var odLower = search['od.l'];
                    var odUpper= search['od.u'];

                    search['od.l']=odUpper;
                    search['od.u']=odLower;
                }

                if(parseInt(search['yr.l']) > parseInt(search['yr.u'])){
                    var yrLower = search['yr.l'];
                    var yrUpper= search['yr.u'];

                    search['yr.l']=yrUpper;
                    search['yr.u']=yrLower;
                }

                // update URL parameters with sort
                var sortStr = sort.set(params.sort, $routeParams);
                if (!sortStr) sortStr = sort.set(sortableCriteria[0].sort, $routeParams);
                search['sort'] = sortStr;

                // trigger URL update
                $location.search(search);

            }

            model.formatUom = function (record) {
                if ("Miles" == record.UOM) return "mi";
                if ("Kilometers" == record.UOM) return "km";
                return undefined;
            };

            model.shortEventDateEDTFormatter = function (rowData) {
                var auctionDate = undefined;

                if (__doesArrayContain(rowData.AUCTION_CH_LST, "lb")) {
                    if (typeof(moment) != "undefined" && typeof(moment.tz) != "undefined" && !isUndefinedOrNull(moment) && !isUndefinedOrNull(moment.tz)
                        && !isUndefinedOrNull(rowData)) {
                        var new_date = moment(rowData.LIVEBLOCK_SCHEDULED_SALE_DATE);
                        var aucDate = new_date.locale('en').tz("America/New_York").format("MM/DD/YY");
                        var aucTime = new_date.locale('en').tz("America/New_York").format("h:mm A zz");

                        auctionDate = aucDate + "<br/>" + aucTime;

                    }
                } else {
                    if (__doesArrayContain(rowData.AUCTION_CH_LST, "rl")) {
                        var new_date = moment(rowData.LIVEBLOCK_SCHEDULED_SALE_DATE);
                        var aucDate = new_date.locale('en').format("MM/DD/YY");
                        auctionDate = aucDate;
                    }
                }

                return auctionDate;
            };

            model.shotEventTimeFormatter = function (rowData) {
                var auctionTime = undefined;
                if (!isUndefinedOrNull(rowData)) {
                    var new_date = moment(rowData.LIVEBLOCK_SCHEDULED_SALE_DATE);
                    var aucTime = new_date.locale('en').format("h:mm A zz");
                    auctionTime = aucTime + "EDT";
                }

                return auctionTime;
            };

            function __doesArrayContain(array, text) {
                var line = array.join(",")
                return line.indexOf(text) >= 0;
            }

            var auchMap = {
                "rl": "Run List", "lb": "Liveblock"
            };

            model.formatAuctionChannel = function (record) {
                var auchLst = record.AUCTION_CH_LST;
                var text = auchLst.map(function (x) {
                    return auchMap[x]
                }).join("/");

                return text;
            };

            /*model.isDealerBlock = function(record)
             {
             return record.AUCTION_CH_LST.some(function(x){return x == 'ol'});
             };*/

            model.isRunlistLiveblock = function (record) {
                return record.AUCTION_CH_LST.some(function (x) {
                    return (x == 'rl' || x == 'lb')
                });
            };

            model.millisToStringDisplay = function (ms) {
                function iter(ms, t, units) {
                    if (units.length == 0) return t;
                    var unit = units.pop();
                    var rem = ms % unit.n;
                    if (rem < ms)
                        return iter(rem, t + (ms - rem) / unit.n + unit.t + " ", units)
                    else
                        return iter(ms, t, units);
                }

                return iter(ms, "", [{n: 1000, t: "s"}, {n: 60000, t: "m"}, {n: 3600000, t: "h"}, {
                    n: 86400000,
                    t: "d"
                }]);
            };

            model.millisToDateDisplay = function (ms, format) {
                /*
                 return millisParser(ms, "ms").reduce(function(acc, curr) {
                 if (curr != 0 || acc.length > 0) return " " + acc + curr['value'] + curr['unit'];
                 return acc;
                 }, "");//*/
                return moment(ms).format(format);
            };

            function millisParser(ms, precision) {
                var date = new Date(ms);
                var allPrecisionLevels =
                    [{
                        "p": "y", "f": function (d) {
                            return d.getFullYear()
                        }
                    },
                        {
                            "p": "mm", "f": function (d) {
                            return d.getMonth() + 1
                        }
                        },
                        {
                            "p": "d", "f": function (d) {
                            return d.getDate()
                        }
                        },
                        {
                            "p": "h", "f": function (d) {
                            return d.getHours()
                        }
                        },
                        {
                            "p": "m", "f": function (d) {
                            return d.getMinutes()
                        }
                        },
                        {
                            "p": "s", "f": function (d) {
                            return d.getSeconds()
                        }
                        },
                        {
                            "p": "ms", "f": function (d) {
                            return d.getMilliseconds()
                        }
                        }];

                var map = {"y": 1, "mm": 2, "d": 3, "h": 4, "m": 5, "s": 6, "ms": 7};

                var levels = allPrecisionLevels.slice(0, map[precision]);
                return levels.map(function (l) {
                    var o = {};
                    o['unit'] = l.p;
                    o['value'] = l.f(date);
                    return o
                });
            }

            model.psiType = function (r) {
                if (r.PSI == "0" || r.PSI == "1") {
                    if (OpenlaneSearchEngine.physicalAuctionTypes.ADESA !== r.PAT) return "PDI";

                    var low = 2500;
                    var high = 50000;
                    var price = r.START_PRICE;
                    if (!price && price !== 0) price = r.BUY_PRICE;
                    if (!price) price = 0;
                    if (low <= price && price <= high) return "PSI";

                    if (r.AUCTION_CH_LST && r.AUCTION_CH_LST.some(function (x) {
                            return x == OpenlaneSearchEngine.auctionChannels.LIVEBLOCK
                        })) return "PSI";
                }
                return undefined;
            };

            model.truncateStr = function (str, len) {
                if (!str) return str;
                if (str.length > len + 3) return (str.slice(0, len) + "...");
                return str;
            };

            model.stpaFormatter = function (record) {
                var match = /[A-Za-z]+\s*-\s*(.*)$/.exec(record.STPA);
                if (match) return match[1];
                else return "";
            };

            model.mtags = {};
            function updateMtags(rs) {
                model.mtags = {};
                rs.forEach(function (r) {
                    if (r.MTAG_TYPE_ID && r.MTAG_NAME) {
                        model.mtags[r.VEHICLE_ID] = r.MTAG_TYPE_ID.map(function (x, i) {
                            return {"type": x, "title": r.MTAG_NAME[i]}
                        });
                    }
                });
            }

            function executeInScope(_scope, action) {
                if (_scope.$$phase) action();
                else _scope.$apply(action);
            }

            $scope.addtoWatchlistVehicleAddViewLinks = function (vehicleId, options) {
                jQuery.ajax({
                    url: 'watchlist_add.ajax',
                    cache: false,
                    data: {'vehicleId': vehicleId},
                    success: function (data) {
                        executeInScope($scope, function () {
                            recordIndex[vehicleId]["IN_WATCHLIST"] = true
                        })
                    }
                });
            };

            $scope.markVehicleAsReviewed = function (vehicleId) {
                jQuery.ajax({
                    url: 'markviewed_add.ajax',
                    cache: false,
                    data: {'vehicleId': vehicleId, 'action': 'add'},
                    success: function (data) {
                        executeInScope($scope, function () {
                            recordIndex[vehicleId]["REVIEWED"] = true
                        })
                    }
                });
            };

            $scope.hideVehicle = function (vehicleId, options) {
                jQuery.ajax({
                    url: 'hidevehicle_add.ajax',
                    cache: false,
                    data: {'vehicleId': vehicleId, 'action': 'add'},
                    success: function (data) {
                        executeInScope($scope, function () {
                            recordIndex[vehicleId]["HIDDEN"] = true
                        })
                    }
                });
            };

            $scope.visited = function (rowData) {
                var visited = '';

                if (rowData.REVIEWED) {
                    visited = "visited";
                }

                return visited;

            };


            model.rowClass = function (rowData) {
                var rowClass = getRowClass(rowData.VEHICLE_ID);
                return rowClass;
            };

            model.isLiveBlock = function (rowData) {
                var auctionChLst = rowData.AUCTION_CH_LST;

                if (!isUndefinedOrNull(auctionChLst)) {
                    for (var i = 0; i < auctionChLst.length; i++) {
                        if (auctionChLst[i] == 'lb') {
                            return dataService.getCurrentTranslation()["search.lb"];
                        }
                    }
                }

                return '';
            };

            model.buildCR = function (rowData) {
                var result = "";
                var spaceIfEmpty = "&nbsp;";

                if (rowData.THIRD_PARTY_INSPECTION) {


                    if (!isUndefinedOrNull(rowData.INSPECTION_BRANDING) && rowData.INSPECTION_BRANDING.length > 0 && rowData.INSPECTION_BRANDING[0] != 0) {


                        if (!isUndefinedOrNull(rowData.INSPECTION_BRANDING[0])) {


                            if (rowData.INSPECTION_BRANDING[0] == 4) {

                                result = "<div><img title='"+dataService.getCurrentTranslation()['searchCrThirdParty0']+"' src='resource/image/common/cr-green.jpg'/></div>";
                            }
                            else if (rowData.INSPECTION_BRANDING[0] == 5) {
                                //result =  "<img src=\"themes/default/images/cr-green.jpg\" title=\"" + rowData['INSPECTION_BRANDING'][2] + "\" class=\"icons_style\"/>";
                                result = spaceIfEmpty;
                            }
                            else if (rowData.INSPECTION_BRANDING[0] == 3) {

                                result = "<div><img title='"+translation+"' src='resource/image//common/cr-purple.jpg'/></div>";
                            }
                        } else {
                            result = spaceIfEmpty;
                        }
                    } else {
                        result = "<div><img title='"+dataService.getCurrentTranslation()['searchCrThirdParty']+"' src='resource/image/common/icon_conditionreport.jpg'/></div>";

                    }

                } else {
                    result = spaceIfEmpty;
                }
                return result;
            };

            model.odometerFormatter = function (rowData) {
                var value = "";
                if (!isUndefinedOrNull(rowData)) {
                    value = formatNumber(rowData.ODOMETER);
                }
                return value;
            };

            model.runlistTableLocation = function (rowData) {
                var pos = rowData.STPA.indexOf("-");
                var result = rowData.STPA;

                if (pos >= 0) {
                    result = rowData.STPA.substr(pos + 1);
                }

                return result.trim();
            };

            $scope.orderByField = 'VIN';
            $scope.reverseSort = false;


            var getRowClass = function (vehicleId) {
                return "row_" + vehicleId;
            };

            $scope.onClick_RunListDetailsLink = function (vehicleId) {
                var runListVehicleAnnouncementRow = angular.element("#announcementRow_" + vehicleId);
                var displayStyle = runListVehicleAnnouncementRow.css("display");

                displayStyle = (displayStyle == "none") ? "" : "none";
                runListVehicleAnnouncementRow.css("display", displayStyle);
                isCookiedAnnouncement = false;
            };

            $scope.optionAnnouncement = function (options) {
                var listOptions =[];

                var newOptions = options.replace(/~/g," ");

                if(newOptions != ''){

                    $scope.optionSearchResult = searchService.searchResultOptions().then(
                        function(data){

                            for(var i=0;i<=newOptions.split(" ").length-1;i++){
                                var optionIndex = data.data.announcementOptions.map(function (item) {
                                    return item.optionCode;
                                }).indexOf(newOptions.split(" ")[i]);

                                if(data.data.announcementOptions[optionIndex] == null){
                                    listOptions.push({optionCode:newOptions.split(" ")[i],meaning:newOptions.split(" ")[i]});
                                }else{
                                    listOptions.push(data.data.announcementOptions[optionIndex]);
                                }
                            }

                        },
                        function(err){
                        }
                    );


                    $scope.announOptionValue = listOptions;
                }

                angular.element('#optionModal').foundation('reveal', 'open');
            };

            $scope.optionBuilder = function (options) {
                return options.replace(/~/g," ");
            };

            $scope.numberFormatter = function (options) {
                var num = 0;
                if (!isUndefinedOrNull(options)) {
                    num = formatNumber(options);
                }
                return num;
            };

            $scope.gradeFormatter = function (grade) {

                if(grade == -1){
                    grade='Other';
                }
                return grade;
            };

            $scope.showAllAnnouncements = function () {

                angular.element("#srp-Table").find("tr.announcementRow").css("display", "");
                angular.element("#showAllButton").css("display", "none");
                angular.element("#hideAllButton").css("display", "");
                $cookies.put('announcementShoworHide',true);
            };

            $scope.hideAllAnnouncements = function () {
                angular.element("#srp-Table").find("tr.announcementRow").css("display", "none");
                angular.element("#showAllButton").css("display", "");
                angular.element("#hideAllButton").css("display", "none");
                $cookies.put('announcementShoworHide',false);
            };

            function scroll_up_button_enable() {
                angular.element(document).ready(function () {
                    angular.element(window).scroll(function () {
                        if (angular.element(this).scrollTop() > 320) {
                            angular.element('#floating_scroll_div').fadeIn();
                        } else {
                            angular.element('#floating_scroll_div').fadeOut();
                        }
                    });
                });
            }

            $scope.scrollUpClick = function () {
                angular.element("html,body").animate({scrollTop: 0}, {
                    duration: 500,
                    easing: 'swing'
                });
            };

            $scope.isLast = function(last) {
                if(last == true) {
                    angular.element(document).foundation('equalizer', 'reflow');

                    if($cookies.get('announcementShoworHide')=='true' && isCookiedAnnouncement){
                        $scope.showAllAnnouncements();
                    }
                }
            };

            //pass searching SRP callback url to save in cash service to use at VDP:
            $scope.$watch(function () {
                return $location.search();
            }, function (value, oldValue) {
                if (value) {
                    CacheSearchParams.storeLastSearchParams('','','','', model.numFound);
                }
            });

        }

})();



// WEBPACK FOOTER //
// ./app/search/result/SearchResultController.js